module.exports = __webpack_public_path__ + "img/np-typography.ff1b24f5.webp";